import type { SwiperProps, SwiperRef } from 'swiper/react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';

import './styles.css';

import { getWrapperMaxWidth } from '@/features/utils/utils';
import { cn } from '@/lib/utils';

export type CarouselRenderItemInfo<ItemType> = {
  item: ItemType;
  index: number;
};

export type CarouselRenderItem<ItemType> = ({
  item,
  index,
}: CarouselRenderItemInfo<ItemType>) => React.ReactElement<any> | null;

export type CarouselProps<ItemType> = {
  config: SwiperProps;
  items: ItemType[];
  renderItem: CarouselRenderItem<ItemType>;
  sideGradient?: boolean;
  classNames?: {
    root?: string;
    swiper?: string;
    swiperWrapper?: string;
    swiperSlide?: string;
  };
} & { ref?: React.RefObject<SwiperRef | null> };

export type CarouselInstance = typeof Swiper;

export const Carousel = <ItemType,>({
  config,
  items,
  renderItem,
  classNames,
  ref,
}: CarouselProps<ItemType>) => {
  return (
    <div
      className={cn(
        getWrapperMaxWidth('full'),
        'flex w-full after:z-10',
        classNames?.root
      )}
    >
      {/* Needed because of some TS types mismatch in ReactNode definitions */}
      {/* eslint-disable-next-line */}
      {/* @ts-ignore */}
      <Swiper ref={ref} className={classNames?.swiper} {...config}>
        {items.map((item, i) => (
          // eslint-disable-next-line
          // @ts-ignore
          <SwiperSlide key={i} className={classNames?.swiperSlide}>
            {/* eslint-disable-next-line */}
            {/* @ts-ignore */}
            {renderItem({ item, index: i })}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
